import { InputForm, Error, SubmitButton } from "components";
import { CreateRoleInput, RoleError } from "modules/auth/role/store/actionType";

interface OwnProps {
  formData: CreateRoleInput;
  errors: RoleError;
  loading: boolean;
  header: string;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit?: React.MouseEventHandler<HTMLButtonElement>;
}
export const RoleForm: React.FC<OwnProps> = ({
  formData,
  handleChange,
  handleSubmit,
  errors,
  loading,
  header,
}) => (
  <form>
    <h2 className="text-xl font-bold my-3">{header}</h2>
    <div className="pb-3">
      <InputForm
        label="Role"
        type="text"
        id="name"
        name="name"
        value={formData.name}
        onChange={handleChange}
      />
      {errors.name && <Error>{errors.name}</Error>}
    </div>
    <div className="pb-3">
      <InputForm
        label="Description"
        type="text"
        id="description"
        name="description"
        value={formData.description}
        onChange={handleChange}
      />
      {errors.description && <Error>{errors.description}</Error>}
    </div>
    <div className="flex">
      <SubmitButton loading={loading} onClick={handleSubmit} />
    </div>
  </form>
);
